var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[_c('iframe',{attrs:{"src":"https://meajuda.gitbook.io/apoio-suporte/comunicados/comunicados","width":"100%","height":"740px","frameborder":"0"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }